import Tooltip from '@material-ui/core/Tooltip'
import { withStyles, Theme } from '@material-ui/core/styles'

export default withStyles((theme: Theme) => ({
  popper: {
    marginLeft: 10,
    marginRight: 10,
  },
  arrow: {
    color: theme.palette.primary.main,
  },
  tooltip: {
    fontSize: '0.75rem',
    backgroundColor: theme.palette.primary.main,
    maxWidth: 400,
    /*'@media (min-width: 375px)': {
      maxWidth: 600,
    },*/
    /*marginLeft: 10,
    marginRight: 10,*/
    padding: '4px 8px',
  },
  tooltipPlacementTop: {
    top: 15,
    '@media (min-width: 768px)': {
      top: 5,
    },
  },
  tooltipPlacementBottom: {
    bottom: 15,
    '@media (min-width: 768px)': {
      bottom: 5,
    },
  },
}))(Tooltip)
